import logo from "../assets/img/logo.png";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

// css
import "./Navbar.css";
import { useState } from "react";

function CollapsibleExample() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar
      key={"sm"}
      bg="light"
      expand={"sm"}
      className="mb-1  bg-transparent shadow-none"
      expanded={expanded}
    >
      <Navbar.Brand href="/">
        <img
          alt=""
          src={logo}
          width="auto"
          height="40"
          className="d-inline-block align-top"
        />
        {/* React Bootstrap */}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-sm`} onClick={() => setExpanded(expanded ? false : "expanded")} />
      <Navbar.Offcanvas
        id={`offcanvasNavbar-expand-sm`}
        aria-labelledby={`offcanvasNavbarLabel-expand-sm`}
        placement="end"
        className="custom_navbar_offcanvas"
      >
        <Offcanvas.Header closeButton  onClick={() => setExpanded(false)}>
          <Offcanvas.Title id={`offcanvasNavbarLabel-expand-sm`}>
            Offcanvas
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="justify-content-end  flex-grow-1 pe-3">
            <Link to="/" className=" me-4 nav-item-Link  " onClick={() => setExpanded(false)}>
              <Icon icon="fluent:home-16-regular" className="me-1" />
              Home
            </Link>
            <Link
              eventKey={2}
              to="/contact-us"
              className=" me-1 nav-item-Link  "
              onClick={() => setExpanded(false)}
            >
              <Icon icon="fluent:call-32-regular" className="me-1" />
              Contact us
            </Link>
          </Nav>
        </Offcanvas.Body>
      </Navbar.Offcanvas>
    </Navbar>
  );
}

export default CollapsibleExample;